(() => {
  if (customElements.get('milwaukee-footer')) return;
  customElements.define('milwaukee-footer', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.columns = [...this.querySelectorAll('.mw-footer__column')];
      this.desktop = matchMedia('(min-width:768px)');
      this.sync = () => this.columns.forEach(column => {
        column.open = this.desktop.matches;
        column.querySelector('summary').setAttribute('tabindex', this.desktop.matches ? '-1' : '0');
      });
      this.desktop.addEventListener('change', this.sync, options);
      this.addEventListener('click', event => {
        if (this.desktop.matches && event.target.closest('summary')) event.preventDefault();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const column = this.columns.find(el => el.dataset.blockId === event.detail.blockId);
        if (column) column.open = true;
      }, options);
      this.sync();
    }
    disconnectedCallback() { this.controller.abort(); }
  });
})();
